import {
  ErrorMessage,
  FlexContainer,
  LoadingPlaceholder,
  TenancyBlock,
} from 'components';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { tenancyStatusMap } from 'config/userFields';

/**
 * TenanciesList
 *
 * @return {JSX.Element}
 */
const TenanciesList = ({ tenancies, onClick }) => {
  return (
    <FlexContainer gap column>
      {tenancies.map((t) =>
        t.isInitialized ? (
          t.error ? (
            <ErrorMessage description={t.error} />
          ) : (
            <TenancyBlock
              key={t.data.tenancyUid}
              title={
                t.isFuture
                  ? tenancyStatusMap.futureTenancy
                  : t.isCurrent
                  ? tenancyStatusMap.currentTenancy
                  : tenancyStatusMap.pastTenancy
              }
              price={t.data.payments?.rentAmount}
              dateStart={fromSwiftDate(t.data.dates?.startDate)}
              dateEnd={fromSwiftDate(t.data.dates?.endDate)}
              onClick={onClick(t.data.tenancyUid)}
              highlight={t.data.tenancyStatus !== 'currentTenancy'}
            />
          )
        ) : (
          <LoadingPlaceholder spinner />
        )
      )}
    </FlexContainer>
  );
};

TenanciesList.displayName = 'TenanciesList';

export default TenanciesList;
